import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/lib/auth/auth-client";
import { buildNoindexHead } from "@/lib/noindex-seo";
import Page from "@/pages/admin";

export const Route = createFileRoute("/admin")({
  head: () => buildNoindexHead("Admin", "/admin"),
  component: () => (
    <ProtectedRoute requireAdmin>
      <Page />
    </ProtectedRoute>
  ),
});
